// extracted by mini-css-extract-plugin
export default {"overlay":"Tooltip_overlay__s+-DO","arrow":"Tooltip_arrow__gvMhN","icon":"Tooltip_icon__llCoz"};